<template>
  <div class="columns is-multiline">
    <Sub title="Impianto di ventilazione meccanica controllata" tag="VM" v-model:elements="implant.ventilation_systems" v-slot="slotProps" :codes="implant.codes">
      <Ventilation :element="slotProps.element" />
    </Sub>
  </div>
</template>
  
<script>
import Ventilation from './_10-ventilation/ventilation'

export default {
  components: {
    Ventilation
  },

  props: {
    implant: Object
  },
  emits: ['update:implant']
}
</script>